import { ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';
import { keyframes, styled } from '@mui/material';
import { SettingsDetailContainerContext } from './settingsDetailContext';

const fade = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideIn = keyframes`from { transform: translateX(28px); opacity: 0.4; } to { transform: none; opacity: 1; }`;

const Backdrop = styled('div')({
  position: 'absolute',
  inset: 0,
  zIndex: 1,
  backgroundColor: 'rgba(3, 6, 12, 0.55)',
  animation: `${fade} 0.16s ease`,
});

const Panel = styled('aside')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  zIndex: 2,
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  borderLeft: `1px solid ${theme.palette.divider}`,
  boxShadow: '-30px 0 70px -20px rgba(0, 0, 0, 0.7)',
  animation: `${slideIn} 0.2s cubic-bezier(0.4, 0, 0.2, 1)`,
}));

type Props = {
  onClose: () => void;
  children: ReactNode;
  width?: string;
};

export const SettingsDetailPanel = ({ onClose, children, width = '100%' }: Props) => {
  const container = useContext(SettingsDetailContainerContext);
  if (!container) return null;

  return createPortal(
    <>
      <Backdrop onClick={onClose} aria-hidden />
      <Panel style={{ width }} role="dialog" aria-modal="true">
        {children}
      </Panel>
    </>,
    container,
  );
};

export default SettingsDetailPanel;
